import React from 'react';
import { useTranslation } from 'react-i18next';
import { theme } from '../utils/theme';

const FAQ = () => {
  const { t } = useTranslation('faq');

  return (
    <section className={theme.section + ' bg-[#6D9773]'}>
      <div className={theme.container}>
        <h2 className={theme.text.h1 + ' mb-8 text-center text-white'}>
          {t('title')}
        </h2>
        <div className="divide-y divide-white/10 bg-[#6D9773]">
          {Object.entries(t('questions', { returnObjects: true })).map(([key, value]) => (
            <details key={key} className="group">
              <summary className="text-white font-semibold py-4 px-4 outline-none cursor-pointer focus:underline flex justify-between items-center">
                <span>{value.question}</span>
                <span className="transform group-open:rotate-180 transition-transform duration-200">⌄</span>
              </summary>
              <div className="px-4 pb-4">
                <p className="text-white/90">
                  {value.answer}
                </p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;